import React, { useState, useEffect } from "react";
import { GoMoon, GoSun } from "react-icons/go";
import GlobalStyles from "../../global/GlobalStyles";

const DarkModeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check for saved theme preference
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) return storedTheme === "dark";

    // Default to light mode if nothing is stored
    localStorage.setItem("theme", "light");
    return false;
  });

  const toggleDarkMode = () => {
    setIsDarkMode((prevMode) => {
      const newMode = !prevMode;
      document.documentElement.classList.toggle("dark", newMode);
      localStorage.setItem("theme", newMode ? "dark" : "light");

      // Update theme-color meta tag
      const metaTag = document.querySelector('meta[name="theme-color"]');
      if (metaTag) {
        metaTag.setAttribute("content", newMode ? "#0f172a" : "#ffffff");
      }

      return newMode;
    });
  };

  useEffect(() => {
    // Apply the correct theme on initial load
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
      const metaTag = document.querySelector('meta[name="theme-color"]');
      if (metaTag) metaTag.setAttribute("content", "#0f172a");
    } else {
      document.documentElement.classList.remove("dark");
      const metaTag = document.querySelector('meta[name="theme-color"]');
      if (metaTag) metaTag.setAttribute("content", "#ffffff");
    }
  }, [isDarkMode]);

  return (
    <button onClick={toggleDarkMode} className={GlobalStyles.buttonRound}>
      {isDarkMode ? <GoSun /> : <GoMoon />}
    </button>
  );
};

export default DarkModeToggle;
